(function () {
  'use strict';

  if (window.__MRJ_AB_INITIALIZED__) return;
  window.__MRJ_AB_INITIALIZED__ = true;

  var DEBUG = /[?&]mrj_debug=1/.test(location.search);
  function log() {
    if (DEBUG) console.log.apply(console, ['[MRJ]'].concat([].slice.call(arguments)));
  }

  var CARD_SELECTOR = '.product-item';
  var CAROUSEL_SELECTOR = '.mrjcarousel, .flickity-enabled, [data-flickity]';

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  var forcedParam = new URLSearchParams(window.location.search).get('mrj');
  var isForced = ['1', '2', '3', '4'].indexOf(forcedParam) > -1;

  var torba = [];
  function karistir(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function gorselNoCek() {
    if (isForced) {
      return parseInt(forcedParam, 10);
    }
    if (torba.length === 0) torba = karistir([1, 2, 3, 4]);
    return torba.pop();
  }

  function addGorselParamToLink(url, gorselNo) {
    if (!url || url.charAt(0) === '#' || url.indexOf('javascript:') === 0) return url;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'mrj_gorsel=' + gorselNo;
  }

  function getMainLink(card) {
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].closest('.color-siblings-drawer')) continue;
      return links[i];
    }
    return null;
  }

  function getMatchedProduct(card) {
    var link = getMainLink(card);
    if (!link) return null;

    var path = (link.getAttribute('href') || '').split('?')[0].split('#')[0]
      .toLowerCase().replace(/\/+$/, '');
    var parts = path.split('/products/');
    if (parts.length < 2) return null;
    var handle = parts[1];
    return handle ? { handle: handle, name: handle } : null;
  }

  function getFlickity(carousel) {
    try {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var f = window.Flickity.data(carousel);
        if (f) return f;
      }
      if (window.jQuery) {
        var jf = window.jQuery(carousel).data('flickity');
        if (jf) return jf;
      }
    } catch (e) {}
    return null;
  }

  function applyVisual(card, index) {
    if (index === 0) {
      card.setAttribute('data-mrj-applied', 'true');
      return;
    }
    if (card.dataset.mrjTrying) return;
    card.dataset.mrjTrying = 'true';

    var touched = false;
    card.addEventListener('touchstart', function () { touched = true; }, { passive: true, once: true });

    function trySelect() {
      var carousel = card.querySelector(CAROUSEL_SELECTOR);
      if (!carousel) return false;

      var imgs = carousel.querySelectorAll('.carousel-cell img');
      if (index >= imgs.length) {
        var f = getFlickity(carousel);
        if (f && imgs.length > 0 && index >= imgs.length) {
          log('Üründe yeterli görsel yok:', imgs.length, 'istenen:', index + 1);
          return 'NOT_ENOUGH_IMAGES';
        }
        return false;
      }

      var img = imgs[index];
      var lSrc = img.getAttribute('data-flickity-lazyload-src');
      var lSrcset = img.getAttribute('data-flickity-lazyload-srcset');
      if (lSrc && img.src !== lSrc) img.src = lSrc;
      if (lSrcset && img.srcset !== lSrcset) img.srcset = lSrcset;

      var flkty = getFlickity(carousel);
      if (flkty && typeof flkty.select === 'function') {
        if (flkty.selectedIndex !== index) flkty.select(index, false, true);
        log('Flickity select başarılı:', index + 1);
        card.setAttribute('data-mrj-applied', 'true');
        return true;
      }

      var dots = carousel.querySelectorAll('.flickity-page-dots .dot');
      if (dots[index]) {
        dots[index].click();
        log('Dot click başarılı:', index + 1);
        card.setAttribute('data-mrj-applied', 'true');
        return true;
      }
      return false;
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      var res = trySelect();
      if (res === true) {
        clearInterval(timer);
        setTimeout(function () { if (!touched) trySelect(); }, 1000);
        return;
      }
      if (res === 'NOT_ENOUGH_IMAGES' || attempts > 50) {
        clearInterval(timer);
        card.setAttribute('data-mrj-applied', 'false');
        log('Görsel uygulanamadı:', card);
      }
    }, 200);
  }

  var applyObserver = null;
  var seenObserver = null;

  if ('IntersectionObserver' in window) {
    applyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        applyObserver.unobserve(card);
        applyVisual(card, parseInt(card.getAttribute('data-mrj-gorsel'), 10) - 1);
      });
    }, { rootMargin: '800px 0px' });

    seenObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        seenObserver.unobserve(card);
        sendImpression(card);
      });
    }, { threshold: 0.5 });
  }

  function sendImpression(card, tries) {
    if (card.dataset.mrjImpressionSent) return;
    var state = card.getAttribute('data-mrj-applied');
    tries = tries || 0;
    if (state === null && tries < 60) {
      setTimeout(function () { sendImpression(card, tries + 1); }, 200);
      return;
    }
    card.dataset.mrjImpressionSent = 'true';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mrj_ab_impression',
      ab_test_name: '4_lu_gorsel_testi',
      ab_variant: 'gorsel_' + card.getAttribute('data-mrj-gorsel'),
      product_name: card.getAttribute('data-mrj-handle'),
      applied_status: state === 'true' ? 'success' : (state === 'false' ? 'failed' : 'timeout'),
      ab_forced: isForced
    });
  }

  function processCards() {
    if (!isMobile()) return;

    var cards = document.querySelectorAll(CARD_SELECTOR + ':not([data-mrj-processed])');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var matched = getMatchedProduct(card);
      if (!matched) return;

      var gorselNo = gorselNoCek();
      card.setAttribute('data-mrj-processed', 'true');
      card.setAttribute('data-mrj-gorsel', gorselNo);
      card.setAttribute('data-mrj-handle', matched.name);

      log('Eşleşti:', matched.name, '-> Görsel No:', gorselNo);

      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (a.closest('.color-siblings-drawer')) return;

        var href = a.getAttribute('href');
        if (href && href.indexOf('mrj_gorsel=') === -1) {
          a.setAttribute('href', addGorselParamToLink(href, gorselNo));
        }

        if (!a.dataset.mrjTracked) {
          a.dataset.mrjTracked = 'true';
          a.addEventListener('click', function () {
            var state = card.getAttribute('data-mrj-applied');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'mrj_ab_click',
              ab_test_name: '4_lu_gorsel_testi',
              ab_variant: 'gorsel_' + gorselNo,
              product_name: matched.name,
              applied_status: state === 'true' ? 'success' : (state === 'false' ? 'failed' : 'pending'),
              ab_forced: isForced
            });
          });
        }
      });

      if (applyObserver) {
        applyObserver.observe(card);
        seenObserver.observe(card);
      } else {
        applyVisual(card, gorselNo - 1);
        sendImpression(card);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processCards);
  } else {
    processCards();
  }

  window.addEventListener('resize', function () {
    setTimeout(processCards, 200);
  });

  function startObserver() {
    if (!document.body) { setTimeout(startObserver, 50); return; }
    var debounceTimer = null;
    new MutationObserver(function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processCards, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  startObserver();
})();